import * as React from 'react';

import PropTypes from 'prop-types';

import {Avatar} from 'shells/avatar/avatar';
import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import styles from './leaderboard-list-row.module.css';

export class LeaderboardListRow extends React.Component {
    static propTypes = {
        position: PropTypes.number.isRequired,
        rowType: PropTypes.string.isRequired,
        entity: PropTypes.object.isRequired,
        count: PropTypes.string.isRequired,
        total: PropTypes.object,
    };

    render() {
        const countString =
            this.props.rowType === 'sales' ? `${this.props.count} won` : this.props.count;

        return (
            <div className={styles.container}>
                <div className={styles.position}>{this.props.position}</div>
                <div className={styles['avatar-entity-container']}>
                    <div className={styles.avatar}>
                        <Avatar
                            type={this.props.entity.type}
                            initials={this.props.entity.initials}
                            avatarUrl={this.props.entity.avatarUrl}
                        />
                    </div>
                    <div
                        className={
                            this.props.entity.isEnabled === false
                                ? styles['disabled-entity']
                                : styles.entity
                        }
                    >
                        <LinkedEntity {...this.props.entity} />
                    </div>
                </div>
                <div className={styles.totals}>{countString}</div>
                {this.props.rowType === 'sales' ? (
                    <div className={styles.sales}>
                        {this.props.total.prefix}
                        {this.props.total.formatted}
                        {this.props.total.suffix}
                    </div>
                ) : undefined}
            </div>
        );
    }
}
